import { createSlice } from "@reduxjs/toolkit";
import {
  activateUserAccount,
  signup,
  userResendOtp,
} from "../../thunks/authThunk";
import { message } from "antd";

const initialState = {
  isLoading: false,
  signupStatus: "idle", // "idle" | "loading" | "success" | "failed"
  signupStatusMsg: null,
  status: null,
  error: null,
};

export const signupSlice = createSlice({
  name: "signup",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(signup.pending, (state) => {
        state.isLoading = true;
        state.signupStatus = "loading";
        state.error = null;
        state.signupStatusMsg = null;
      })
      .addCase(signup.fulfilled, (state, action) => {
        state.isLoading = false;
        state.signupStatus = "success";
        state.signupStatusMsg = action.payload.message;
        if (action?.payload.status == 1) {
          message.success(action?.payload?.message, 5);
        } else {
          message.error(action?.payload?.message, 5);
        }

        state.status = action.payload.status;
        state.errorResponse = action.payload;
        state.error = null;
      })
      .addCase(signup.rejected, (state, action) => {
        state.isLoading = false;
        state.signupStatusMsg = action.payload.message;
        state.status = action.payload.status;
        state.signupStatus = "failed";
        state.error = "Something went wrong!";
        message.error(action.payload.message, 5);
      });
    // user account activating two factor authentication
    builder
      .addCase(activateUserAccount.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
        state.updateUserAccount = false;
      })
      .addCase(activateUserAccount.fulfilled, (state, action) => {
        state.isLoading = false;
        state.updateUserAccount = action.payload;
        action?.payload?.status === 1
          ? message.success(action.payload.message)
          : message.error(action.payload.message);
      })
      .addCase(activateUserAccount.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });

    // user resending opt for two factor authentication
    builder
      .addCase(userResendOtp.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
        state.updateUserOtp = false;
      })
      .addCase(userResendOtp.fulfilled, (state, action) => {
        state.isLoading = false;
        state.updateUserOtp = action.payload;
        message.success(action.payload.message);
      })
      .addCase(userResendOtp.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        message.error("Something went wrong!");
      });
  },
});

export default signupSlice.reducer;
